<template>
  <div>
    <HeaderCompo :jobcount="totalJob" />

    <form class="search-form" @submit.prevent="LoadPositionData">
      <div class="form-row">
        <div class="col-xs-12 p-2 col-md">
          <input
            placeholder="Search by keyword"
            type="search"
            class="search-field search-keyword form-control"
            v-model="searchCriteria.keysearch"
          />
        </div>
        <div class="col-xs-12 p-2 col-md">
          <div>
            <VueMultiselect
              v-model="vLoc"
              :options="locations"
              :multiple="true"
              :group-select="true"
              :limit="2"
              deselect-label="❌"
              select-label="✔"
              select-groupLabel="All"
              deselect-groupLabel="❌ All"
              group-values="province"
              group-label="country"
              placeholder="select location"
              track-by="name"
              label="name"
            >

            <template v-slot:multipleLabel="{ values }">
            <div class="multiselect-multiple-label">
              {{ values.length }} characters selected
            </div>
          </template>
            </VueMultiselect>




          </div> 


    
        </div>
        <div class="col-xs-12 p-2 col-md">

          <VueMultiselect
            v-model="vCom"
            :options="Company"
            :multiple="true"
            placeholder="select client"
            track-by="name"
            label="name"
            deselect-label="❌"
            select-label="✔"
            select-groupLabel="All">

          </VueMultiselect>

        </div>
        <div class="col-xs-12 p-2 col-md-2">
          <button
            id="abbc"
            type="submit"
            class="btn btn-secondary btn-apply width-100"
            style="background-color: rgb(16, 65, 165)"
          >
            Search
          </button>
        </div>
      </div>
      <!---->
      <!---->
    </form>

    <div class="container mb-5 px-xl-5">
      <ul class="list-unstyled mx-3 mx-sm-4 mx-md-5 px-lg-5 pb-4">
        <li class="media" v-for="d in workData" :key="d.Id">
          <div class="media-body">
            <div id="tot">
              <router-link
                :to="{ name: 'jobview', params: { id: d.JobKeyId } }"
                class="text-secondary"
              >
                <h5 class="mt-0 mb-1 primary-color">
                  {{ d.JobPositionName }}
                </h5>
              </router-link>

              <span class="text-secondary">
                <span v-if="d.JobWorkArea != ''" style="margin-right: 10px">
                  <i class="fas fa-map-marker-alt"></i>
                  {{ d.JobWorkArea }}
                </span>
                <br />
                <span
                  ><i class="fas fa-building"></i>
                  {{ d.JobCompany }}
                </span>
                <br />
              </span>
            </div>

            <router-link :to="{ name: 'jobview', params: { id: d.JobKeyId } }">
              <button
                type="button"
                class="btn btn-secondary btn-apply "
                style="background-color: rgb(16, 65, 165)"
              >
                Apply
              </button>
            </router-link>
          </div>
        </li>
      </ul>

      <div class="row justify-content-center">
        <div class="col-md-2 col-6">
          <button
            class="btn btn-secondary btn-apply width-100"
            type="button"
            :disabled="currentPage === 1"
            @click="onPageClick(-1)"
          >
            Prev
          </button>
        </div>
        <div class="col-md-2 col-6">
          <button
            class="btn btn-secondary btn-apply width-100"
            type="button"
            :disabled="currentPage === totalPage"
            @click="onPageClick(1)"
          >
            Next
          </button>
        </div>
      </div>
    </div>

    <FooterCompo />
  </div>
</template>

<script>
// import MainHeaderCompo from "@/components/MainHeaderCompo.vue";
import HeaderCompo from "@/components/HeaderCompo.vue";
import FooterCompo from "@/components/FooterCompo.vue";
import axios from "axios";
import variables from "@/variables";
import VueMultiselect from "vue-multiselect";  






export default {
  components: {
    HeaderCompo,
    FooterCompo,
    VueMultiselect,



  },
  data() {
    return {


      workData: [],
      breadcrumbsData: [{ name: "Opening", link: "/" }],

      searchCriteria: {
        keysearch: "",
        joblocation: "",
        jobcompany: "",
        pagnumber: 1,
        region:"TH",
      },

      currentPage: 1,
      perPage: 1,
      totalPage: {},

      vLoc: [],
      locations: [
        // {
        //   country: "Thailand",
        //   province: [
        //     { name: "Bangkok", id: 12 },
        //     { name: "Phra Nakhon Si Ayutthaya", id: 13 },
        //   ],
        // },
        // {
        //   country: "Thailandx",
        //   province: [
        //     { name: "Bangkokx", id: 12 },
        //     { name: "Phra Nakhon Si Ayutthayax", id: 13 },
        //   ],
        // },
      ],
      vCom: [],
      Company: [
        // { name: "CSI Group", id: 1 }
      ],
    };
  },
  methods: {
    LoadPositionData() {
      this.searchCriteria.pagnumber = this.currentPage;

      let Location = "";
      for (let i = 0; i < this.vLoc.length; i++) {
        let obj = this.vLoc[i];

        if (i == 0) {
          Location = Location + obj.id;
        } else {
          Location = Location + "," + obj.id;
        }
      }
      console.log(Location);

      let Company = "";
      for (let i = 0; i < this.vCom.length; i++) {
        let obj = this.vCom[i];

        if (i == 0) {
          Company = Company + obj.id;
        } else {
          Company = Company + "," + obj.id;
        }
      }
      console.log(Company);

      this.searchCriteria.jobcompany = Company;
      this.searchCriteria.joblocation = Location;

      

      console.log(this.searchCriteria);

      axios
        .post(
          variables.API_URL + "position/SearchPosition",
          this.searchCriteria
        )
        .then((response) => {
          this.workData = response.data;
          this.currentPage = this.workData[0].currentPage;
          this.perPage = this.workData[0].per_page;
          this.totalPage = this.workData[0].total_page;
          this.totalJob = this.workData[0].total_job;

          // console.log(JSON.stringify(this.workData))
        })
        .catch((error) => {
          console.log(error);
        });
    },

      LoadLocationData() {
        axios
          .post(variables.API_URL + "position/LoadLocationData")
          .then((response) => {
            this.locations = response.data;
            // console.log(JSON.stringify(response.data));
            // console.log(JSON.stringify(this.locations));
          })
          .catch((error) => {
            console.log(error);
          });
      },

      LoadCompanyData() {
        axios
          .post(variables.API_URL + "position/LoadCompanyData")
          .then((response) => {
            this.Company = response.data;
            //console.log(JSON.stringify(response.data));
            //console.log(JSON.stringify(this.locations))
          })
          .catch((error) => {
            console.log(error);
          });
      },

    onPageClick(num) {
      this.currentPage = this.currentPage + num;
      this.LoadPositionData();
    },

    ApplyJob(link) {
      link = "/job/dotnet_rubix";
      this.$router.push(link);
    },
    scrollToBottom() {

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });

    },
  },
  created(){



        document.title = "CSI-GROUPS Open Position"
    },
  mounted: function () {




    this.LoadLocationData();
    this.LoadCompanyData();

    this.currentPage = 1;
    this.LoadPositionData();

    this.scrollToBottom();
  },
};
</script>

<style scoped>


a {
    color: var(--bs-link-color);
    text-decoration: none;
}

.search-form {
  width: fit-content;
  margin: 0px auto 20px;
  padding: 10px;
  width: 60%;
}
.form-row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.col-md {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.width-100 {
  width: 100%;
}
.btn-apply,
.btn-apply:hover {
  background-color: #1041a5 !important;
  border-color: #1041a5 !important;
}
.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
}


.col-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 30%;
    min-width: 100px;
}

.media {
  /* display: flex !important; */
  align-items: flex-start;
  padding: 0 0 16px 0;
}

.media-body {
  display: flex !important;
  justify-content: space-between;
  flex: 1;
  padding: 5px 0px;
}

.btn:disabled {
  background: #dddddd;
}

@media (min-width: 768px) {
  .col-md {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-md-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
}




</style>